import axios from 'axios';
import { config } from '../../../config';
import { getUsersessionFromLocalStorage } from './Verification';
let API_ROOT_URL = config.API_ROOT_URL;
if (window.hiver_config) {
    API_ROOT_URL = window.hiver_config.V2_API_URL;
}

/**
 *
 * @param {Object} inputs Contains the type of http request 'get'/'post' etc
 * @param {String} URL url for the http call
 * @param {Object} data the post request parameters
 */
function getRequestParams(inputs, url, data) {
    if (inputs.type.toLowerCase() === 'get') {
        return {
            method: inputs.type,
            url,
            withCredentials: true,
            params: data
        };
    }
    return {
        method: inputs.type,
        url,
        data,
        withCredentials: true
    };
}
/**
 * Wrapper around axios which adds hiver api root url and csrf token by default to the http call
 * @param {Object} inputs contains keys(url, params, callback, onfail) required to make a http call
 */
function HiverAxios(inputs, isTest) {
    
    var data;
    const meta = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = meta ? meta.getAttribute('content') : 'raraasndkadaad.fake_token';
    if(!(inputs.params?.usersession)){
        if(!inputs.params) inputs.params = {};
        inputs.params.usersession = getUsersessionFromLocalStorage();
    }
    if (inputs.formData) {
        inputs.params.append('_csrf_token', csrfToken);
        data = inputs.params;
    }
    else {
        const fields = { _csrf_token: csrfToken };
        data = Object.assign(fields, inputs.params);
    }
    let url = API_ROOT_URL + inputs.url;
    url = encodeURI(url);
    if (isTest)
        return axios(getRequestParams(inputs, url, data));
    axios(getRequestParams(inputs, url, data)).then(response => {
        inputs.callback(response);
    }).catch((response) => {
        if (inputs.onfail) {
            inputs.onfail(response);
            return;
        }
    });
}

export { HiverAxios };
